import { useState, type ReactNode } from 'react';
import { RedirectContext } from './RedirectContext';
import { deeplinkValidator } from '../utils/deeplink';

export function RedirectProvider({ children }: { children: ReactNode }) {
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);

  const handleClose = () => {
    if (typeof window === 'undefined') return;

    // Resolve the redirect URL from the API response (stored in context) or, as a fallback,
    // the route query param — the error screen may render before the API flow has run.
    const redirectUrlFromParams = new URLSearchParams(window.location.search).get('redirectUrl');
    const finalRedirectUrl = redirectUrl ?? redirectUrlFromParams;

    // Re-validate the deep link against the allow-list before redirecting. A tampered or
    // stale deep link dead-ends benignly instead of shipping the member to a hostile scheme.
    if (finalRedirectUrl && deeplinkValidator.isAllowed(finalRedirectUrl)) {
      // Redirect to the surface app deeplink
      window.location.assign(finalRedirectUrl);
    } else {
      // Fallback: go back or close window (host shell intercepts)
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.close();
      }
    }
  };

  return (
    <RedirectContext.Provider value={{ redirectUrl, setRedirectUrl, handleClose }}>
      {children}
    </RedirectContext.Provider>
  );
}
